import React from 'react';
import product1 from '../assets/product1.png'
import product2 from '../assets/product2.png'
import '../style.css';

const Products = (props) => {
    const handleRedirection = (product) => {
        if(!props.company) return;
        props?.redirectToStep(product);
    };

    return (
        <div className="container">
            <div className="image-container1">
                <div className="product-card" onClick={() => handleRedirection('product1')}>
                    <img src={product1} alt="Product 1" className="image" />
                    <h3>Daily Hospital Cash Health Plan</h3>
                    {/* <p>Product 1 Sub-heading</p> */}
                </div>
                {/* <div className="product-card" onClick={() => handleRedirection('product2')}>
                    <img src={product2} alt="Product 2" className="image" />
                    <h3>Daily Hospital Cash Health Plan</h3>
                    <p>Product 2 Sub-heading</p>
                </div> */}
            </div>
        </div>


    )
}

export default Products;